import Box from "@mui/material/Box";
import { useOutletContext } from "react-router-dom";
import { CloudUploadOutlined } from "@mui/icons-material";
import { shippingPartnerDrawerElements } from "./data";
import { Typography } from "@mui/material";
import FileUpload from "./FileUpload/FileUpload";
import CommonFiles from "./CommonFiles/CommonFiles";
import RecoJobs from "./RecoJobs/RecoJobs";
import FileLogs from "./FileLogs/FileLogs";

const ShippingPartnerRecoDashboard = () => {
	const [pathName, service] = useOutletContext();

	const tabComponents = {
		[shippingPartnerDrawerElements.shipping_partner_reco.types.partner_file_upload.key]: {
			...shippingPartnerDrawerElements.shipping_partner_reco.types.partner_file_upload,
			component: <FileUpload activeService={service} />,
		},
		[shippingPartnerDrawerElements.shipping_partner_reco.types.partner_file_logs.key]: {
			...shippingPartnerDrawerElements.shipping_partner_reco.types.partner_file_logs,
			component: <FileLogs activeService={service} />,
		},
		[shippingPartnerDrawerElements.shipping_partner_reco.types.jobs.key]: {
			...shippingPartnerDrawerElements.shipping_partner_reco.types.jobs,
			component: <RecoJobs activeService={service} />,
		},
		[shippingPartnerDrawerElements.shipping_partner_reco.types.view_common_files.key]: {
			...shippingPartnerDrawerElements.shipping_partner_reco.types.view_common_files,
			component: <CommonFiles activeService={service} />,
		},
	};

	return (
		<Box sx={{ minHeight: "100vh", background: "#f8f9fa", p: 3 }}>
			<Box sx={{ maxWidth: 800, mx: "auto" }}>
				{/* Compact Header */}
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						gap: 1.5,
						mb: 3,
						background: "white",
						p: 2,
						borderRadius: 2,
						boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
						border: "1px solid #e5e7eb",
					}}>
					<CloudUploadOutlined sx={{ color: "#6b7280", fontSize: 20 }} />
					<Typography variant="h6" sx={{ fontWeight: 600, color: "#111827", fontSize: "1.1rem" }}>
						{service?.name || "Dashboard"}
					</Typography>
				</Box>

				{/* Compact Content */}
				<Box
					sx={{
						background: "white",
						borderRadius: 2,
						boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
						border: "1px solid #e5e7eb",
						p: 3,
					}}>
					{tabComponents?.[pathName]?.component}
				</Box>
			</Box>
		</Box>
	);
};

export default ShippingPartnerRecoDashboard;
